import { Outlet, useLocation } from "react-router-dom"
import MarketplaceNav from "../../components/navigation/MarketplaceNav"

interface Props {
  guideOpened: any
  setGuideOpened: any
}

export default function FindACoachLayout(props: Props) {
  const location = useLocation()
  const isSharedView = location.pathname.includes("shared")

  return (
    <>
      {!isSharedView && (
        <MarketplaceNav
          guideOpened={props.guideOpened}
          setGuideOpened={props.setGuideOpened}
        />
      )}
      <Outlet />
    </>
  )
}
